
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';



export const productionService = {
    getProductionList,productionListByDate, productionSearch, productionDetails,
    productionFinishedItem, submitProduction, deleteProduction, productionAction

};





async function  getProductionList() {
   return apiClient.get(`/production/production-list`,  authHeader());
}



async function  productionListByDate(dateForm) {
    return  apiClient.post(`/production/production-by-date`,dateForm, authHeader());
}


async function  submitProduction(dateForm) {
    return  apiClient.post(`/production/submit-production`,dateForm, authHeader());
}

async function  productionAction(dateForm) {
    return  apiClient.put(`/production/production-action`,dateForm, authHeader());
}

async function  productionSearch(searchText) {
    return  apiClient.get(`/production/production-search?search=${searchText}`, authHeader());
}

async function  productionDetails(ProductionId) {
    return  apiClient.get(`/production/production-details/${ProductionId}`, authHeader());
}


async function  deleteProduction(ProductionId) {
    return  apiClient.delete(`/production/delete-production/${ProductionId}`, authHeader());
}

async function  productionFinishedItem(ProductionId) {
    return  apiClient.get(`/production/production-finished-item/${ProductionId}`, authHeader());
}












